module.exports = __webpack_public_path__ + "img/linkgie.969421dc.png";